<allianz-modal-layout
  [config]="modalConfig"
  [buttons]="actionButtons"
>
  <div class="flex flex-col">
    <p
      nxCopytext
      class="nx-font-weight-regular"
      [innerHtml]="message"
    ></p>
    @if (additionalMessage) {
      <p
        class="nx-margin-top-2xs"
        nxCopytext
        [innerHtml]="additionalMessage"
      ></p>
    }
  </div>
  @if (customComponent) {
    <div class="nx-margin-top-m">
      <ng-template [cdkPortalOutlet]="customComponent"></ng-template>
    </div>
  }
</allianz-modal-layout>
